export default __webpack_public_path__ + "static/customiser-5085c9a982a3a96ae6bedcc275cd5902.mp4";